import $ from 'jquery';
import { $clickableContainer, $main, $html, createSpinner } from './variables';

// member gallery / iframe 
if ($clickableContainer.length) {
  $clickableContainer.each(function () {
    const $clickable_icon_open = $('.js__clickable_icon_open', this);

    $clickable_icon_open.on('click', function (e) {
      // remove click event from the a tag 
      e.preventDefault();

      // get url from the link data attribute 
      let url = $(this).data('url');

      // overlay html
      let $overlay = $(
        `<div class='js__overlay bg-[#1a1a1a] top-0 right-0 w-full h-full fixed z-[200]'>
            <iframe src='${url}' class='w-full h-full js__clickable_iframe opacity-0 transition-all'></iframe>
            <div class='md:max-w-ml-12 left-4 md:left-8 right-4 md:right-8 lg:left-1/2 lg:-translate-x-1/2 lg:w-full absolute top-4 flex justify-end'>
               <div class='js__member_close cw-close-icon'><span class='bg-zar-gold'></span><span class='bg-zar-gold'></span></div>
            </div>
         </div>`);

      // create loading spinner with logo 
      let loadingElement = createSpinner("absolute top-1/2 left-1/2 -translate-x-1/2 animate-zar-pulse");

      // append overlay 
      $main.append($overlay);

      // append the spinner to the overlay for better ux 
      $overlay.append(loadingElement);

      // show iframe after its content has been loaded 
      $('.js__clickable_iframe').on('load', () => {
        // remove the spinner wrapper
        $('.js__spinner_wrapper').remove();

        // show the iframe 
        $('.js__clickable_iframe').removeClass('opacity-0');
      })

      // avoid background-scrolling
      $html.addClass('overflow-y-hidden');

      // remove overlay on icon click and revert to initial scrolling
      $(document).on('keydown', function (e) {
        if (e.key === "Escape") {
          // remove the overlay 
          $overlay.remove();

          // reset the html overflow 
          $html.removeClass('overflow-y-hidden');

          // reset the eventListener 
          $(document).off();
        }
      });

      $('.js__member_close').on('click', () => {
        // remove the overlay 
        $overlay.remove();

        // reset the html overflow 
        $html.removeClass('overflow-y-hidden');

        // reset the eventListener 
        $('.js__member_close').off();
      });

    });
  });
}